module.exports = __webpack_public_path__ + "static/media/cover-2.8ccc2d4b.jpg";